// extracted by mini-css-extract-plugin
export default {"container":"PaginationControls_container__GyFp4","pageButton":"PaginationControls_pageButton__fqyLr"};